module.exports = __webpack_public_path__ + "img/9b94772e0215add9edbddf4b0142490.721470e2.png";